import { MRT_ColumnDef } from "mantine-react-table"
import { useSnapshot } from "valtio"
import ScenarioGridItem from "./Scenario.grid"
import { Link } from "react-router"
import { store } from "@/stores/stores"
import useFetchStatic from "@/hooks/useFetchStatic"
import StaticLayout from "@/components/layout/StaticLayout"
import { Scenario } from "@/gen"

function Scenarios() {
  const snap = useSnapshot(store)
  useFetchStatic("template")

  const columns: MRT_ColumnDef<Scenario>[] = []

  return (
    <StaticLayout<Scenario>
      title="Scenarios"
      entityLabel="Scenario"
      routePath="/scenarios"
      storeName="scenario"
      layout="center"
      GridComponent={ScenarioGridItem}
      // searchProps={{
      //   placeholder: "Search scenarios",
      // }}
      searchFn={(search, scenario) => {
        return scenario.name.toLowerCase().includes(search.toLowerCase())
      }}
      columns={columns}
      state={{
        showSkeletons: !snap.user.fetched,
      }}
      gridBefore={
        <Link
          to="/scenarios/templates"
          className="group fc h-48 w-full max-w-[337px] flex-col gap-2 rounded-2xl bg-primary text-lg font-bold text-white"
        >
          <div
            className={`shadow-gridButton outline-primary-light fc size-[34px] rounded-full bg-white text-primary outline-0 transition-all group-hover:outline-8`}
          >
            <IconMingcuteAddFill className={`size-4`} />
          </div>
          Add Scenario
        </Link>
      }
    />
  )
}

export default Scenarios
